<template>
  <div class="company-intro-navbar-component">
    <router-link class="item company-news"
                 :to="{ name: 'ArticleList', query: { type: 'companyNews' } }"
                 v-if="!hideCompanyNews"
    >
      <span>公司动态</span>
    </router-link>
    <router-link class="item school-cooperate"
                 :to="{
                    name: 'CourseList',
                    query: { type: 'toBusiness', filterBar: 0, showFilterBar: 0 },
                 }"
                 v-if="!hideSchoolCooperate"
    >
      <span>学校合作</span>
    </router-link>
    <router-link class="item school-cooperate"
                 to="/article/175"
    >
      <span>城市合伙人</span>
    </router-link>
    <router-link class="item join-us"
                 :to="{ name: 'JoinUs' }"
                 v-if="!hideJoinUs"
    >
      <span>加入我们</span>
    </router-link>
  </div>
</template>

<script>
  export default {
    name: 'CompanyIntroNavBar',
    props: {
      hideCompanyNews: {
        type: Boolean,
        default: false,
      },
      hideSchoolCooperate: {
        type: Boolean,
        default: false,
      },
      hideJoinUs: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .company-intro-navbar-component {
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: @font-size-base;
    background: @color-white;
    box-shadow: 0 3px 2px 0 fade(@color-gray-lighter, .3);
    color: @color-text-primary;
  }
  .item {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1.2;
    .icon-right {
      margin-right: @size-extra-small;
      font-size: @font-size-base;
    }
    &:not(:last-child) {
      position: relative;
      &:after {
        position: absolute;
        content: '';
        width: 1px;
        height: @size-base;
        background: @color-gray-light;
        right: 0;
        top: 38px;
      }
    }
  }

</style>
